import React, { useState } from 'react';
import axios from 'axios';
import { Alert, Input as AntdInput, Input } from 'antd';
import './LoginPage.scss';

const LoginPage = () => {
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const sanitizePhone = (value) => value.replace(/[^0-9]/g, '').trim();

  const login = async () => {
    setError(null);
    let userRes;
    try {
      userRes = await axios.post('/api/login', { phone: sanitizePhone(phone), password });
    } catch (e) {
      if (e.response?.status === 403 && e.response?.data?.code === 'INACTIVE_USER') {
        setError('החשבון לא פעיל. לפתיחה נא לפנות בוואצאפ אל 055-8893770');
      } else {
        setError('פרטי ההתחברות שגויים');
      }
      return;
    }
    if (userRes.isGuide) window.location.assign('/admin/guide');
    if (userRes.isManager) window.location.assign('/admin/manager');
    window.location.assign('/');
  };

  return (
    <div className="login-page">
      <a
        className="info-stripe"
        href="http://chabadisrael.co.il/shevet13"
        target="_blank"
        rel="noopener noreferrer"
      >
        למידע והתרשמות על תכנית &apos;שבט 13&apos;
      </a>
      <div className="login-form">
        <div className="login-welcome"><span>&nbsp;&nbsp;&nbsp;&nbsp;ברוכים הבאים לשבט!</span></div>
        <span className="font-dakar">אנא הכנס פרטי התחברות</span>
        <div>
          <AntdInput
            className="input-field"
            name="phoneNo"
            type="tel"
            onChange={(ev) => setPhone(sanitizePhone(ev.target.value))}
            placeholder="טלפון"
            onPressEnter={login}
            style={{ direction: 'rtl' }}
          />
        </div>
        <div>
          <AntdInput.Password
            className="input-field"
            name="password"
            onChange={(ev) => setPassword(ev.target.value)}
            placeholder="סיסמא"
            onPressEnter={login}
            style={{ direction: 'rtl' }}
          />
        </div>
        {error && (
          <div>
            <Alert message={error} type="error" />
          </div>
        )}
        <div>
          <button onClick={login} type="button" className="login-button">התחברות</button>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
